module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10LLx0R/tc-custom/9780830894260.jpg?1696025100716",
      "alt": "This image is the cover for the book Slow Church Study Guide"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Slow Church Study Guide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("High-speed internet. Rapid rewards. Quick thinking. Fast food. Fast . . . church? "), _c('em', [_vm._v("Slow Church")]), _vm._v(" by Chris Smith and John Pattison has been eagerly received by a people who are ready to be invited out of franchise faith and back into the kingdom of God. This eleven-session study guide provides an opportunity to reflect on the message of this groundbreaking book both individually and in community. Each session features")]), _vm._v("  A guide to "), _c('em', [_vm._v("lectio divina")]), _vm._v("  Suggested videos that can be watched online A series of in-depth questions expanded from what is currently in the book A quote for reflection  "), _c('p', [_vm._v("Here is an opportunity to begin to develop a deeper and richer community where people know each other well and love one another as Christ loved the church.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C. Christopher Smith, John Pattison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("C. Christopher Smith is editor of "), _c('em', [_vm._v("The Englewood Review of Books")]), _vm._v(", and a member of the Englewood Christian Church community on the urban Near Eastside of Indianapolis.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0